import { defineComponent as _defineComponent } from 'vue'
import DokuWikiWrapper from './DokuWikiWrapper.vue'
import {
  onBeforeMount,
  ref,
} from 'vue'
import {
  onBeforeRouteUpdate,
  useRoute,
} from 'vue-router/composables'
import logger from './logger.ts'


export default /*#__PURE__*/_defineComponent({
  __name: 'DokuWikiWrapperReactivity',
  setup(__props) {

const currentRoute = useRoute()

const routeWikiPage = ref<string>('')
const routeQuery = ref<Record<string, string>>({})

const onRouteChange = (to: Route) => {
  routeWikiPage.value = to.params.wikiPage ?? ''
  routeQuery.value = Object.fromEntries(Object.entries(to.query || {}).filter(([key]) => key !== 'id'))
}

onBeforeMount(() => {
  logger.debug('ON BEFORE MOUNT', { ...currentRoute }, { ...window?.history?.state })
  onRouteChange(currentRoute)
})

onBeforeRouteUpdate((to, from, next) => {
  logger.debug('ON BEFORE ROUTE UPDATE', {
    to: { ...to },
    from: { ...from },
    windowState: { ...(window?.history?.state || {}) },
  })
  onRouteChange(to)
  next()
})


return { __sfc: true,currentRoute, routeWikiPage, routeQuery, onRouteChange, DokuWikiWrapper }
}

})